import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export const enrollLoggedInPlayer = async (playerId) => {
    const baseUrl = process.env.REACT_APP_API_URL;
    const authToken = localStorage.getItem('authToken');

    try {

        const res = await fetch(`${baseUrl}/api/newsletter/subscribe`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({ user_id: playerId })
        });

        if (!res.ok) throw new Error();
        return true;
    } catch (e) {
        MySwal.showValidationMessage('Could not update preferences. Please try again later.');
        return false;
    }
};

export const promptGuestEmail = async () => {
    const { value: email } = await MySwal.fire({
        title: 'Join Newsletter',
        input: 'email',
        inputPlaceholder: 'Enter your email address',
        showCancelButton: true,
        confirmButtonColor: '#28a745'
    });

    if (email) {
        try {
            const baseUrl = process.env.REACT_APP_API_URL;
            const res = await fetch(`${baseUrl}/api/newsletter/subscribe`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: email })
            });
            if (!res.ok) throw new Error();
            return true;
        } catch (e) {
            MySwal.showValidationMessage('Subscription failed. Please try again later.');
        }
    }
    return false;
};

export const executeAppNewsAction = async (config) => {
    const {
        action,
        isGuest,
        playerId,
        authToken,
        baseUrl,
        setPlayerPrefReceiveNewsletter // Pass state setters if needed
    } = config;

    if (!action || action.type === 'none') return true;

    switch (action.type) {
        case 'url':
            window.open(action.target_url, '_blank');
            return true;

        case 'api_call':
            // If it's an API call but they are a guest, pivot to a prompt if defined
            if (isGuest && action.guest_fallback_type === 'input_prompt') {
                return await handleDynamicInput(action.guest_prompt_config, authToken, baseUrl);
            }
            return await runApiFetch(action, playerId, authToken, baseUrl, setPlayerPrefReceiveNewsletter);

        case 'input_prompt':
            return await handleDynamicInput(action, authToken, baseUrl);

        default:
            console.warn("Unknown action type:", action.type);
            return true;
    }
};

const runApiFetch = async (action, playerId, authToken, baseUrl, setPlayerPrefReceiveNewsletter) => {
    // Replace ${playerId} in the endpoint string
    const endpoint = action.endpoint.replace('${playerId}', playerId);

    try {
        const response = await fetch(`${baseUrl}${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: action.payload // JSON string from WordPress
        });

        if (!response.ok) throw new Error();

        // Optional: If you want the app to react to specific payload keys
        if (action.payload.includes('pref_receive_newsletter') && setPlayerPrefReceiveNewsletter) {
            setPlayerPrefReceiveNewsletter(true);
        }

        return true;
    } catch (error) {
        MySwal.showValidationMessage(action.fail_message || 'Request failed');
        return false;
    }
};

const handleDynamicInput = async (action, authToken, baseUrl) => {
    const { value: userInput } = await MySwal.fire({
        title: action.input_title,
        input: action.input_type || 'text',
        inputLabel: action.input_label,
        showCancelButton: true,
        confirmButtonColor: '#28a745'
    });

    if (userInput) {
        const payload = action.payload_template.replace('${userInput}', userInput);
        return await runApiFetch({ ...action, payload }, 'guest', authToken, baseUrl);
    }
    return false;
};